<template>
  <b-table
    :data="sectionsList"
    :striped="true"
    :loading="loading"
    :paginated="showPagination"
    :per-page="rowsPerPage"
    default-sort="sectionId"
    default-sort-direction="asc"
    pagination-position="both"
    height="65vh"
    focusable
    scrollable
    sticky-header
  >
    <b-table-column
      v-slot="props"
      sortable
      field="sectionId"
      :label="$t('SectionId')"
      centered
    >
      {{ props.row.sectionId }}
    </b-table-column>
    <b-table-column
      v-slot="props"
      sortable
      field="SectionExternalId"
      :label="$t('SectionExternalId')"
      centered
    >
      {{ props.row.sectionExternalId }}
    </b-table-column>
    <b-table-column
      v-slot="props"
      sortable
      field="sectionName"
      :label="$t('SectionName')"
      centered
    >
      {{ props.row.sectionName }}
    </b-table-column>
    <b-table-column
      v-slot="props"
      sortable
      field="shoppingCenterGroupName"
      :label="$t('ShoppingCenterGroupName')"
      centered
    >
      {{ props.row.shoppingCenterGroupName }}
    </b-table-column>
    <b-table-column
      v-slot="props"
      :label="$t('Edit')"
      :visible="canEdit"
      centered
    >
      <b-button
        type="is-warning"
        icon-pack="fas"
        icon-right="pencil-alt"
        tag="router-link"
        :to="{
          name: `SectionsAdministrationEdit`,
          params: { id: props.row.sectionId },
          query: { returnTo: $route.path },
        }"
      />
    </b-table-column>
  </b-table>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import localStorageAccess from "@/resourceAccess/localStorageAccess";
import type { Section } from "@/stores/app";

export default defineComponent({
  props: {
    sectionsList: {
      type: Array as PropType<Section[]>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rowsPerPage: 10 as number,
    };
  },
  mounted() {
    const savedRowsPerPage = localStorageAccess.getRowsPerPage("sectionsList");
    if (savedRowsPerPage) {
      this.rowsPerPage = parseInt(savedRowsPerPage, 10) || this.rowsPerPage;
    }
  },
  computed: {
    showPagination(): boolean {
      return this.sectionsList.length > 10;
    },
  },
});
</script>
